import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';
import { email, required } from 'vuelidate/lib/validators';
import PasswordResetInstruction from '@/plugins/graphql/mutations/v2/auth/reset-email-instructions.gql';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import RecaptchaMixin from '@/helpers/mixins/RecaptchaMixin';
import FormValidationsMixin from '../../../helpers/vue_mixins/v2/FormValidationsMixin';
import ViewportSizeMixin from '../../../helpers/mixins/ViewportSizeMixin';
let ForgotPasswordDialog = class ForgotPasswordDialog extends Mixins(FormValidationsMixin, FormMixin, ViewportSizeMixin, RecaptchaMixin) {
    constructor() {
        super(...arguments);
        this.toggle = false;
        this.form = {
            email: null,
        };
    }
    toggleForm() {
        this.toggle = !this.toggle;
    }
    onCancel() {
        this.resetForm();
        this.toggle = !this.toggle;
    }
    async sendResetToken() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            const role = this.$route.params.userType;
            this.requestOnFlight();
            return this.$apollo
                .mutate({
                mutation: PasswordResetInstruction,
                variables: {
                    input: {
                        email: this.form.email,
                        role,
                    },
                },
            })
                .then((result) => {
                const data = result.data.passwordResetEmailInstructions;
                this.successNotification(data.message);
                // this.resetRecaptcha(1);
                this.requestDone();
            })
                .catch((e) => {
                this.errorNotification(e.message);
                this.requestDone();
            })
                .finally(() => {
                this.onCancel();
                // this.resetRecaptcha(1);
                this.requestDone();
            });
        }
    }
};
ForgotPasswordDialog = __decorate([
    Component({
        components: {
            VueRecaptcha,
            BaseTextField,
            FormHeader,
            ActionButton,
        },
        validations: {
            form: {
                email: {
                    required,
                    email,
                },
            },
        },
    })
], ForgotPasswordDialog);
export default ForgotPasswordDialog;
